<template>
  <div class="checkout-page">
    <NavBar />

    <h1>Checkout</h1>

    <div class="checkout-container">

      <!-- CUSTOMER DETAILS -->
      <div class="customer-details">

        <h2>Delivery Information</h2>

        <form @submit.prevent="placeOrder">

          <label>Full Name</label>
          <input
            type="text"
            v-model="customer.name"
            placeholder="Enter your full name"
            required
          >

          <label>Email</label>
          <input
            type="email"
            v-model="customer.email"
            placeholder="Enter your email"
            required
          >

          <label>Phone Number</label>
          <input
            type="tel"
            v-model="customer.phone"
            placeholder="Enter your phone number"
            required
          >

          <label>Delivery Address</label>
          <textarea
            v-model="customer.address"
            placeholder="Enter your delivery address"
            required
          ></textarea>

          <h2 class="payment-title">Payment Method</h2>

<div class="payment-options">

  <label class="payment-option">
    <input
      type="radio"
      value="card"
      v-model="paymentMethod"
    >
    Card Payment
  </label>

   <label class="payment-option">
    <input
      type="radio"
      value="transfer"
      v-model="paymentMethod"
    >
    Bank Transfer
   </label>
   </div>

   <div v-if="paymentMethod === 'card'" class="card-payment">

  <h3>Card Details</h3>

  <label>Card Number</label>
  <input
    type="text"
    v-model="card.number"
    placeholder="1234 5678 9012 3456"
    maxlength="19"
  >

  <div class="card-row">

    <div>
  <label>Expiry Date</label>

  <div class="expiry-selects">

    <select v-model="card.month">
      <option value="">Month</option>
      <option
        v-for="month in months"
        :key="month"
        :value="month"
      >
        {{ month }}
      </option>
    </select>

    <select v-model="card.year">
      <option value="">Year</option>
      <option
        v-for="year in years"
        :key="year"
        :value="year"
      >
        {{ year }}
      </option>
    </select>

  </div>
</div>

    <div>
      <label>CVV</label>
      <input
        type="password"
        v-model="card.cvv"
        placeholder="123"
        maxlength="3"
      >
    </div>

  </div>

</div>

<div v-if="paymentMethod === 'transfer'" class="transfer-payment">

  <h3>Bank Transfer Details</h3>

  <p>
    Please transfer the total amount to the account below.
  </p>

  <div class="bank-details">

    <p>
      <strong>Bank:</strong> Timeless Leather Bank
    </p>

    <p>
      <strong>Account Name:</strong> Timeless Leather
    </p>

    <p>
      <strong>Account Number:</strong> 1234567890
    </p>

    <p>
      <strong>Amount:</strong> ₦{{ total }}
    </p>

  </div>

  <label class="transfer-confirmation">
    <input
      type="checkbox"
      v-model="transferConfirmed"
    >
    I have completed the bank transfer
  </label>

</div>

          <button type="submit" class="place-order">
            Place Order
          </button>

        </form>

      </div>


      <!-- ORDER SUMMARY -->
      <div class="order-summary">

        <h2>Your Order</h2>

        <div
          v-for="(product, index) in cart"
          :key="index"
          class="summary-product"
        >

          <img
            v-if="product.image"
            :src="product.image"
            :alt="product.name"
          >

          <div>
            <h3>{{ product.name }}</h3>
            <p>Quantity: {{ product.quantity }}</p>
            <p>₦{{ product.price * product.quantity }}</p>
          </div>

        </div>

        <div class="total">
          <span>Total</span>
          <strong>₦{{ total }}</strong>
        </div>

      </div>

    </div>

  </div>
</template>


<script>
import NavBar from '../components/NavBar.vue'
export default {
  components: {
    NavBar
  },
  
  data() {
    return {
      cart: [],

      customer: {
        name: '',
        email: '',
        phone: '',
        address: ''
      },

      paymentMethod: 'card',
     card: {
  number: '',
  month: '',
  year: '',
  cvv: ''
},

months: [
  '01', '02', '03', '04', '05', '06',
  '07', '08', '09', '10', '11', '12'
],

years: [
  '2026', '2027', '2028', '2029',
  '2030', '2031', '2032', '2033'
],

transferConfirmed: false
      
    }
  },

  computed: {
    total() {
      return this.cart.reduce((sum, product) => {
        return sum + (product.price * product.quantity)
      }, 0)
    }
  },

  mounted() {
    this.cart = JSON.parse(localStorage.getItem('cart')) || []
  },

  methods: {
   placeOrder() {

  // Check if the cart is empty
  if (this.cart.length === 0) {
    alert('Your cart is empty. Please add a product before checking out.')
    return
  }

  // Check customer details
  if (
    !this.customer.name ||
    !this.customer.email ||
    !this.customer.phone ||
    !this.customer.address
  ) {
    alert('Please fill in all delivery information.')
    return
  }

  // Check card payment details
  if (this.paymentMethod === 'card') {

    if (
      !this.card.number ||
      !this.card.month ||
      !this.card.year ||
      !this.card.cvv
    ) {
      alert('Please fill in all card payment details.')
      return
    }

  }

  // Check bank transfer confirmation
  if (this.paymentMethod === 'transfer') {

    if (!this.transferConfirmed) {
      alert('Please confirm that you have completed the bank transfer.')
      return
    }

  }

  // Save payment method for the success page
  localStorage.setItem('paymentMethod', this.paymentMethod)

  // Remove cart after successful checkout
  localStorage.removeItem('cart')

  // Go to order success page
  this.$router.push('/order-success')
}
  }
}
</script>


<style scoped>

.checkout-page {
  min-height: 100vh;
  padding: 50px 7%;
  background: #f3e5dc;
}

.checkout-page h1 {
  text-align: center;
  color: #333;
  margin-bottom: 40px;
}

.checkout-container {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 35px;
  max-width: 1100px;
  margin: auto;
}

.customer-details,
.order-summary {
  background: #fffaf7;
  padding: 30px;
  border-radius: 10px;
  border: 1px solid #d9b5a4;
}

.customer-details h2,
.order-summary h2 {
  color: #333;
  margin-bottom: 25px;
}

form {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 7px;
  color: #333;
  font-weight: 600;
}

input,
textarea {
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #d9b5a4;
  border-radius: 5px;
  font-family: inherit;
}

textarea {
  height: 100px;
  resize: vertical;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #c76b4a;
}

.place-order {
  padding: 14px;
  border: none;
  border-radius: 5px;
  background: #c76b4a;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 5px;
}

.place-order:hover {
  background: #333;
}

.summary-product {
  display: flex;
  gap: 15px;
  padding: 15px 0;
  border-bottom: 1px solid #e2c9bd;
}

.summary-product img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 5px;
}

.summary-product h3 {
  margin: 0 0 5px;
  color: #333;
}

.summary-product p {
  margin: 3px 0;
  color: #777;
}

.total {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 2px solid #333;
  font-size: 20px;
}

.total strong {
  color: #c76b4a;
}

@media (max-width: 480px) {

  .checkout-page {
    padding: 25px 15px;
  }

  .checkout-page h1 {
    font-size: 25px;
  }

  .customer-details,
  .order-summary {
    padding: 18px;
  }

  .summary-product {
    gap: 10px;
  }

  .summary-product h3 {
    font-size: 15px;
  }

  .summary-product p {
    font-size: 13px;
  }

}

@media (max-width: 768px) {

  .checkout-page {
    padding: 30px 20px;
  }

  .checkout-page h1 {
    font-size: 28px;
    margin-bottom: 30px;
  }

  .checkout-container {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .customer-details,
  .order-summary {
    padding: 20px;
  }

  .customer-details h2,
  .order-summary h2 {
    font-size: 22px;
  }

  input,
  textarea {
    width: 100%;
    box-sizing: border-box;
  }

  .summary-product {
    align-items: center;
  }

  .summary-product img {
    width: 60px;
    height: 60px;
  }

  .total {
    font-size: 18px;
  }

  .place-order {
    width: 100%;
  }

}

.payment-title {
  margin-top: 30px;
}

.payment-options {
  display: flex;
  gap: 25px;
  margin-bottom: 20px;
}

.payment-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.payment-option input {
  margin: 0;
}

.card-payment,
.transfer-payment {
  padding: 20px;
  margin-bottom: 25px;
  background: #f3e5dc;
  border: 1px solid #d9b5a4;
  border-radius: 6px;
}

.card-payment h3,
.transfer-payment h3 {
  color: #333;
  margin-top: 0;
  margin-bottom: 20px;
}

.card-payment input {
  margin-bottom: 15px;
}

.card-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.card-row input {
  width: 100%;
  box-sizing: border-box;
}

.bank-details {
  padding: 15px;
  margin: 15px 0;
  background: #fffaf7;
  border-radius: 5px;
}

.bank-details p {
  margin: 8px 0;
  color: #555;
}

.transfer-confirmation {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.transfer-confirmation input {
  margin: 0;
}

.expiry-selects {
  display: flex;
  gap: 10px;
}

.expiry-selects select {
  flex: 1;
  padding: 12px;
  border: 1px solid #d9b5a4;
  border-radius: 5px;
  background: #fffaf7;
  color: #333;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}

.expiry-selects select:focus {
  outline: none;
  border-color: #c76b4a;
}

</style>